<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="6" sm="8">
        <v-card class="elevation-12">
          <v-toolbar dark flat>
            <v-toolbar-title>Registo</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>

            <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="submit">
              <!--
                Alerts & Loaders
              -->
              <!--<Alerts :aType.sync="response"/>-->
              <div>
                <v-text-field
                  v-model="name"
                  :counter="45"
                  label="Name"
                  @blur="$v.name.$touch()"
                  required
                ></v-text-field>
                <!--
                <p v-if="!$v.name.check_name" style="color: red;">Only accepts characters.</p>
                -->
                <p v-if="!$v.name.maxLength" style="color: red;">Please provide a valid name within the range.</p>
              </div>

              <div>
                <v-text-field
                    v-model="email"
                    hint="Only emails with .com and .net domains are accepted"
                    label="E-mail"
                    @blur="$v.email.$touch()"
                    required
                ></v-text-field>
                <p v-if="!$v.email.email || !$v.email.wbst_suffix" style="color: red;">Please provide a valid email address.</p>
              </div>

              <div>
                <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"

                    label="Password"
                    @blur="$v.password.$touch()"
                    @click:append="showPassword = !showPassword"
                ></v-text-field>
                <p v-if="!$v.password.minLength" style="color: red;">Passwords must be have at least 8 characters.</p>
              </div>

              <div>
                  <v-text-field
                    v-model="passwordConfirm"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPasswordConfirm ? 'text' : 'password'"

                    label="Confirm Password"
                    @blur="$v.passwordConfirm.$touch()"
                    @click:append="showPasswordConfirm = !showPasswordConfirm"
                  ></v-text-field>
                  <p v-if="!$v.passwordConfirm.minLength" style="color: red;">Passwords must be have at least 8 characters.</p>
                  <p v-if="!$v.passwordConfirm.sameAs" style="color: red;">Passwords must be equal.</p>
              </div>

              <div>
                <v-text-field
                  v-model="address"
                  :counter="100"
                  label="Address"
                  required
                  @blur="!$v.address.$touch()"
                ></v-text-field>
                <p v-if="!$v.address.maxLength" style="color: red;">Please provide a valid Address within the range.</p>
              </div>

              <v-text-field
                  v-model="establishment"
                  disabled
                  label="Establishment"
                  required
              ></v-text-field>

              <div>
                <v-text-field
                    v-model="phone"
                    hint="Phone number in the format '(91|92|93|96)9999 999"
                    label="Phone Number"
                    @blur="$v.phone.$touch()"
                    required
                ></v-text-field>
                <p v-if="!$v.phone.check_phone" style="color: red;">Phone number must start with 91,92,93 or 96.</p>
                <p v-if="!$v.phone.numeric" style="color: red;">Phone number must a numeric value.</p>
                <p v-if="!$v.phone.minLength || !$v.phone.maxLength" style="color: red;">Phone number must have 9 digits.</p>
              </div>
              
              <div>
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    min-width="290px"
                    offset-y
                    transition="scale-transition"
                >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="date"
                          v-bind="attrs"
                          v-on="on"
                          label="Birthday"
                          prepend-icon="mdi-calendar"
                          readonly
                          @blur="$v.date.$touch()"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        ref="picker"
                        v-model="date"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        @change="save"
                    ></v-date-picker>
                </v-menu>
                <p v-if="!$v.date.minVal || !$v.date.maxVal" style="color: red;">You must be at least 18 years old to be a manager.</p>
              </div>

              <v-btn class="mr-4" @click="clear">Clear</v-btn>
              <v-btn class="mr-4" @click="cancel"> Cancel</v-btn>
              <v-btn :disabled="$v.$invalid" class="mr-4" color="success" type="submit">
                Sign Up
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required,email,helpers,minLength,maxLength,numeric,sameAs } from 'vuelidate/lib/validators';
import {manager_sign_up} from "../../modules/nite_api";
import VueNotifications from "vue-notifications";

//Check if email contains .com or .net
const wbst_suffix = helpers.regex('alpha',/(\.com|\.net)$/);

//Check if the phone number start with 91,92,93,96 and has 9 elements
const check_phone = helpers.regex('numeric', /^(91|92|93|96)/);

//Check if a name is valid
//const check_name = helpers.regex('alpha',"/[^+*'.:,;«»?!<>#\"$%&/()[]{}-]*/");

export default {
  name: 'Register',
  components: {

  },
  data: () => ({
    date: null,
    menu: false,
    valid: true,
    response: null,
    loading: false,
    name: "",
    address: "",
    establishment: "BA",
    phone: "",
    email: "",
    showPassword: false,
    showPasswordConfirm: true,
    password: "",
    passwordConfirm: "",

  }),
  validations: {
    email: {
      required,
      email,
      wbst_suffix
    },
    phone: {
      required,
      numeric,
      check_phone,
      minLength: minLength(9),
      maxLength: maxLength(9)
    },
    name: {
      required,
      //check_name,
      maxLength: maxLength(45)
    },
    passwordConfirm: {
      required,
      minLength: minLength(8),
      sameAs: sameAs('password')
    },
    password: {
      required,
      minLength: minLength(8)
    },
    date: {
      required,
      minVal: value => value >= '1950-01-01',
      maxVal: value => value <= '2002-12-31'
    },
    address: {
      required,
      maxLength: maxLength(100)
    }
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },

  },

  methods: {
    async submit() {
      this.$refs.form.validate();

      let data =
          {
            "address": this.address,
            "birth": this.date,
            "email": this.email,
            "establishment": "BA",
            "name": this.name,
            "password": this.password,
            "phone": this.phone
          }


      this.loading = true;
      try {
        const response = await  manager_sign_up(data);
        this.response = response.status;
        this.response = response.status;
        await this.$router.push('/sign-in')
        // Success
        console.log(response);
      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);



        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);

        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);

        }
        console.log(error.config);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:
            this.showSuccessMsg({title: 'Success', message: 'Registration was successful!'});
            break;
          case 400:
            this.showErrorMsg({
              title: 'Oops',
              message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
            });
            break;
          case 409:
            this.showErrorMsg({
              title: 'Oops',
              message: 'This email address is already being used! Please try again with other email!'
            });
            break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }



    },

    save(date) {
      this.$refs.menu.save(date);
    },
    clear() {
      this.date = null;
      this.name = '';
      this.address = '';
      this.establishment = 'BA';
      this.phone = '';
      this.email = '';
      this.select = '';
      this.password = '';
      this.passwordConfirm = '';
    },
    cancel() {
      this.$router.go(-1)
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Hello there',
      message: 'That\'s the success!'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Hey you',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Wow, man',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Wow-wow',
      message: 'That\'s the error'
    }
}}
</script>

<style scoped>
</style>
